module.exports = __webpack_public_path__ + "static/media/Shkatulka_2.30b345ae.mp3";